<template>
  <div class="pagoda-tooltip">
    <slot></slot>
    <el-tooltip
      :placement="$attrs.placement || 'top-start'"
      :effect="$attrs.effect || 'light'"
      v-bind="$attrs"
    >
      <i :class="[icon, iconClass]"></i>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'Tooltip',
  inheritAttrs: false,
  props: {
    icon: {
      type: String,
      default: 'el-icon-question'
    },
    iconClass: {
      type: String,
      default: ''
    }
  },
  mounted () {
    console.log(this)
  }
}
</script>
